var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 13.3334C14.6272 13.3334 15.0003 12.9603 15.0003 12.5C15.0003 12.0398 14.6272 11.6667 14.167 11.6667C13.7068 11.6667 13.3337 12.0398 13.3337 12.5C13.3337 12.9603 13.7068 13.3334 14.167 13.3334Z",
    fill: "#7093EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00033 2.50002C5.00033 2.03978 5.37342 1.66669 5.83366 1.66669C6.2939 1.66669 6.66699 2.03978 6.66699 2.50002V3.33335H13.3337V2.50002C13.3337 2.03978 13.7068 1.66669 14.167 1.66669C14.6272 1.66669 15.0003 2.03978 15.0003 2.50002V3.33335H15.8337C17.2144 3.33335 18.3337 4.45264 18.3337 5.83335V14.1667C18.3337 15.5474 17.2144 16.6667 15.8337 16.6667H4.16699C2.78628 16.6667 1.66699 15.5474 1.66699 14.1667V5.83335C1.66699 4.45264 2.78628 3.33335 4.16699 3.33335H5.00033V2.50002ZM3.33366 14.1667V8.33335H16.667V14.1667C16.667 14.6269 16.2939 15 15.8337 15H4.16699C3.70675 15 3.33366 14.6269 3.33366 14.1667Z",
    fill: "#7093EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.da26bfc83b4eb2e5e5c7a8a3aca8ba08.svg";
export { ForwardRef as ReactComponent };